import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import Restaurant from "../components/Restaurant";
import GiftCertificate from "../components/giftCertificate";

class RestaurantContainer extends Component {
  render() {
    return (
      <Routes>
        <Route index element={<Restaurant />} />
        <Route path=":id" element={<Restaurant />} />
        <Route
          path=":restaurantID/:uuid/:emailUUID"
          element={<GiftCertificate />}
        />
        <Route path=":restaurantID/:uuid" element={<GiftCertificate />} />
      </Routes>
    );
  }
}

export default RestaurantContainer;
